import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { setLocale } from './i18n'
import 'animate.css'

setLocale(i18n.locale);

// 监听横竖屏切换并刷新页面，避免布局残留
if (typeof window !== 'undefined') {
  let orientationReloadTimer = null;
  const triggerReload = () => {
    if (orientationReloadTimer) clearTimeout(orientationReloadTimer);
    orientationReloadTimer = setTimeout(() => {
      window.location.reload();
    }, 150);
  };

  window.addEventListener('orientationchange', triggerReload);

  // 补充：部分设备仅通过媒体查询变化体现方向
  const mql = window.matchMedia('(orientation: portrait)');
  if (mql && typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', triggerReload);
  } else if (mql && typeof mql.addListener === 'function') {
    mql.addListener(triggerReload);
  }
}

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
